import React from 'react'
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../common/components/form/form.module'



export default function MentorsUserProfileInfoComponent ({handleInnerFormChange, selectedMentors}: any) {

  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
           
           <InputContainer
              label="FirstName"
              name="FirstName"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'UserProfile.FirstName',
                  selectedMentors?.UserProfile
                )
              }}
              type="text"
              value={selectedMentors?.UserProfile?.FirstName}
          />
    
          <InputContainer
              label="LastName"
              name="LastName"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'UserProfile.LastName',
                  selectedMentors?.UserProfile
                )
              }}
              type="text"
              value={selectedMentors?.UserProfile?.LastName}
          />

          <InputContainer
              label="PersonTitle"
              name="PersonTitle"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'UserProfile.PersonTitle',
                  selectedMentors?.UserProfile
                )
              }}
              type="text"
              value={selectedMentors?.UserProfile?.PersonTitle}
          />
        
     </div>
  }
    expandedPanel="userInfo"
    headerTitle="User Profile"
/>

        </>
  )
}